module.exports = __webpack_public_path__ + "img/inclusion.0c17a1af.svg";